<template>
  <div ref="terms-and-conditions-wrapper" class="terms-and-conditions-wrapper">
    <div
      v-focus-trap
      class="terms-and-conditions-container"
      :class="{
        'terms-and-conditions-container-compact': isMobileScreenOrCompactWidget
      }"
    >
      <div
        class="terms-and-conditions-content"
        :style="{ ...getFontSizeForChatInterface('bodyText') }"
      >
        <div class="terms-and-conditions-header">
          <p
            class="header-text"
            :style="{ ...getFontSizeForChatInterface('title') }"
          >
            {{ getTermsAndConditionsTitle }}
          </p>
        </div>
        <div
          class="details"
          v-html="sanitizeFontStyles(getTermsAndConditionsDetails)"
        />
        <div
          class="card-button"
          role="button"
          tabindex="0"
          :style="{ backgroundColor: botResponseBubbleColor, color: '#FFFFFF' }"
          @click.stop="handleTermsAndConditionsButtonClicked"
          @keydown.enter.stop="handleTermsAndConditionsButtonClicked"
        >
          {{ getTermsAndConditionsConfirmButtonLabel }}
        </div>
        <div
          class="close-btn"
          role="button"
          tabindex="0"
          :style="{ color: botResponseBubbleColor }"
          @click.stop="handleCloseClicked"
          @keydown.enter.stop="handleCloseClicked"
        >
          {{ getTermsAndConditionsCloseButtonLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  emitEventToParentWindow,
  getDeviceType,
  getEventDataPoints
} from '@/services/utils'
import { eventType } from '@/services/constants'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  mixins: [fontSizeMixin],
  data() {
    return {}
  },
  computed: {
    isEventAnalyticsMP() {
      return this.$store.state.widgetConfig?.eventAnalyticsMP || false
    },
    botResponseBubbleColor() {
      return this.$store.state.widgetConfig?.botResponseBubbleColor || '#1E6FF1'
    },
    isMobileScreenOrCompactWidget() {
      return (
        getDeviceType() === 'mobile' ||
        !this.$store.state.isChatWidgetFullScreen
      )
    },
    getTermsAndConditionsTitle() {
      return this.$store.state.termsAndConditions.terms.title
    },
    getTermsAndConditionsDetails() {
      return this.$store.state.termsAndConditions.terms.details
    },
    getTermsAndConditionsConfirmButtonLabel() {
      return this.$store.state.termsAndConditions.terms.button.confirmButtonText
    },
    getTermsAndConditionsCloseButtonLabel() {
      return this.$store.state.termsAndConditions.terms.button.closeButtonText
    }
  },
  mounted() {
    this.sendMixPanelEvent(eventType.TERMS_AND_CONDITION_LOADED)
  },
  methods: {
    sanitizeFontStyles(html) {
      if (!html) return ''
      if (this.$store.getters.isFontFamilyChatInterfaceOverrideEnabled) {
        html = html.replace(/font-family:[^;"]*;?/gi, '')
      }
      if (this.$store.getters.isFontSizeChatInterfaceOverrideEnabled) {
        html = html.replace(/font-size:[^;"]*;?/gi, '')
      }
      return html
    },
    handleTermsAndConditionsButtonClicked() {
      this.sendMixPanelEvent(eventType.TERMS_AND_CONDITION_ACCEPTED)
      this.$store.state.termsAndConditionsAccepted = true
      this.$store.dispatch('updateTermsState', {})
    },
    handleCloseClicked() {
      this.sendMixPanelEvent(eventType.TERMS_AND_CONDITION_REFUSED)
      this.$store.dispatch('minimizeCW')
      emitEventToParentWindow(
        eventType.MINIMIZE_CHAT_WIDGET,
        getEventDataPoints()
      )
    },
    sendMixPanelEvent(eventName) {
      this.isEventAnalyticsMP && this.$segment.global.sendEvent(eventName)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/css/theme.scss';
@import '@/styles/css/commonStyles.scss';

.terms-and-conditions-wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2147483647;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.3);

  .terms-and-conditions-container {
    @include border-radius(var(--radius-chat-inner-component));
    background: #fff;
    padding: 16px;
    width: 100%;
    max-width: 606px;
    box-sizing: border-box;
    height: auto;
    box-shadow:
      0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13),
      0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.4);
    .terms-and-conditions-content {
      .terms-and-conditions-header {
        display: flex;
        align-items: center;
        gap: 8px;

        .header-text {
          line-height: 22px;
          font-weight: 500;
        }
      }

      .details {
        margin-top: 16px;
        margin-bottom: 24px;
        font-size: inherit;
        font-weight: 400;
        line-height: 18px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        a {
          text-decoration: underline;
          color: #1e6ff1;
        }
      }

      .card-button {
        @include border-radius(var(--radius-chat-inner-component));
        cursor: pointer;
        padding: 10px 24px 10px 24px;
        font-size: inherit;
        font-weight: 600;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:focus-visible {
          outline: $tab-focused-outline;
        }
      }

      .close-btn {
        cursor: pointer;
        padding: 10px 24px 10px 24px;
        font-size: inherit;
        font-weight: 600;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:focus-visible {
          outline: $tab-focused-outline;
        }
      }
    }

    &.terms-and-conditions-container-compact {
      position: absolute;
      bottom: 0;
      padding: 24px;
    }
  }
}
</style>
